import { Card, CardBody, Col, Row } from "reactstrap";
import { ConversionRateHeading } from "../../../../utils/Constant";
import ConversionRateTable from "./ConversionRateTable";
import RateChart from "./RateChart";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";

const ConversionRate = () => {
  return (
    <Col xl="5" lg="6" className="col-xl-50">
      <Card>
        <CardHeaderCommon  title={ConversionRateHeading} />
        <CardBody className="conversion-rate pt-0">
          <Row>
            <ConversionRateTable />
            <RateChart />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ConversionRate;
